import { render } from "./superuserlisting.vue?vue&type=template&id=23c27c8f&scoped=true"
import script from "./superuserlisting.js?vue&type=script&lang=js"
export * from "./superuserlisting.js?vue&type=script&lang=js"

import "./superuserlisting.vue?vue&type=style&index=0&id=23c27c8f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c27c8f"]])

export default __exports__